import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core"
import { formatCurrency } from "common/bit/utils/formatters"
import styled from "styled-components"
import PriceListVectorIcon from "../../reusable/icons/PriceListVectorIcon"

const TableWrapper = styled.div`
  overflow-y: auto;
  transform: rotateX(180deg);
  margin-top: 40px;
  &::-webkit-scrollbar {
    height: 4px;
    background-color: transparant;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${(p) => p.theme.colors.notExistentSaphire};
  }
`

const StyledTable = styled(Table)`
  transform: rotateX(180deg);
  .bold {
    font-weight: bold;
  }
`

const StyledTableHead = styled(TableHead)`
  background-color: white;
`

const StyledTableRow = styled(TableRow)`
  border-bottom: 1px solid ${(p) => p.theme.colors.darkGrey};
`

const StyledHeadCell = styled(TableCell)`
  font-size: 12px;
  color: ${(p) => p.theme.colors.black};
  text-align: center;
  padding: 25px 17px;
  border: 1px solid ${(p) => p.theme.colors.darkGrey};
`

const StyledCell = styled(TableCell)`
  font-size: 16px;
  color: ${(p) => p.theme.colors.black};
  text-align: center;
  padding: 25px 17px;
  border: 1px solid ${(p) => p.theme.colors.darkGrey};
`

const StyledCurrency = styled.span`
  color: ${(p) => p.theme.colors.mazdaRed};
  margin-right: 3px;
`

const StyledPrice = styled.span`
  font-size: 20px;
  color: ${(p) => p.theme.colors.mazdaRed};
`

const StyledContainer = styled(Container)`
  ${(p) => p.theme.breakpoints.down("sm")} {
    padding: 0px;
  }
`

const SparePriceListData = ({ data }) => {
  return (
    <>
      {data.length > 0 && (
        <StyledContainer>
          <TableWrapper>
            <StyledTable>
              <StyledTableHead>
                <StyledTableRow>
                  <StyledHeadCell>ספק</StyledHeadCell>
                  <StyledHeadCell>מק״ט פריט</StyledHeadCell>
                  <StyledHeadCell>תיאור</StyledHeadCell>
                  <StyledHeadCell>תיאור באנגלית</StyledHeadCell>
                  <StyledHeadCell>תיאור דגם</StyledHeadCell>
                  <StyledHeadCell>מקורי</StyledHeadCell>
                  <StyledHeadCell>מק"ט ספק</StyledHeadCell>
                  <StyledHeadCell>קוד דגם</StyledHeadCell>
                  <StyledHeadCell>מלאי</StyledHeadCell>
                  <StyledHeadCell>מחיר מרבי מומלץ</StyledHeadCell>
                </StyledTableRow>
              </StyledTableHead>
              <TableBody>
                {data.slice(0, 50).map((replacement, i) => (
                  <StyledTableRow key={i}>
                    <StyledCell>{replacement.provider}</StyledCell>
                    <StyledCell>{replacement.item}</StyledCell>
                    <StyledCell>{replacement.name}</StyledCell>
                    <StyledCell>{replacement.foreignName}</StyledCell>
                    <StyledCell>{replacement.modelDescription}</StyledCell>
                    <StyledCell>
                      {replacement.isOriginal === "מקורי" && (
                        <PriceListVectorIcon />
                      )}
                    </StyledCell>
                    <StyledCell>{replacement.sku}</StyledCell>
                    <StyledCell>{replacement.vehicleModel}</StyledCell>
                    <StyledCell>{replacement.isWithQuantity}</StyledCell>
                    <StyledCell className="bold">
                      <StyledCurrency> ₪</StyledCurrency>
                      <StyledPrice>
                        {formatCurrency(replacement.priceWithTax, 2)}
                      </StyledPrice>
                    </StyledCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </StyledTable>
          </TableWrapper>
        </StyledContainer>
      )}
    </>
  )
}

export default SparePriceListData
